<template>
  <div class="share vh100">
    <img v-if="!isApp&&tip" class="share-tip" src="../assets/images/share_tip.png" alt="tip"/>
    <share-video v-if="type === 1" :info="info" :fromShare="fromShare"/>
    <share-audio v-else-if="type === 2" :info="info" :fromShare="fromShare"/>
    <share-bubble
      v-if="bubbleShow"
      :courseName="info.courseName || '精品课程'"
      :leftChapters = "leftChapters"
      :encourageType = "encourageType"
      :encourageValue = "encourageValue"
      @closeBubble="closeBubble" />
  </div>
</template>

<script>
import keys from 'lodash.keys'
import module from '../modules/share'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import ShareVideo from '../components/Share/ShareVideo'
import ShareAudio from '../components/Share/ShareAudio'
import ShareBubble from '../components/Share/ShareBubble'
import ShareMaker from '../lib/shareMaker'
import { isxxx } from '../mixins'

export default {
  computed: {
    ...mapState(module.name, keys(module.state)),
    ...mapGetters(module.name, keys(module.getters))
  },

  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions)),

    closeTip () {
      this.tip = false
    },
    closeBubble () {
      this.set({bubbleShow: false})
    }
  },
  mixins: [
    isxxx
  ],
  data () {
    return {
      tip: false,
      fromShare: false,
    }
  },

  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },

  created () {
    const type = this.$route.query.type || 1
    this.setShareType(type)
    this.setCourse(this.$route.query)
    this.fromShare = this.$route.query.shareMark === 'signIn' ? true : false
    this.tip = this.$route.query.shareMark === 'signShare' ? true : false

    setTimeout(() => {
      this.closeTip()
    }, 3000)
    this.init()
  },

  beforeDestroy () {
    this.set({bubbleShow: false})
    this.$store.unregisterModule(module.name)
  },

  components: {
    ShareVideo,
    ShareAudio,
    ShareBubble
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

$global-width: 750;

.share {
  /*height: 100%;*/
  width: 100%;
  background-image: url(../assets/images/share_bg.png);
  background-size: 100% 100%;
  overflow: hidden;

  &-tip {
    position: fixed;
    right: rem(27);
    top: 0;
    z-index: 999;
    height: rem(130);
    width: rem(240);
  }
}
</style>
